import React from 'react';
import {makeStyles} from '@material-ui/core/styles/index';
import IconButton from '@material-ui/core/IconButton';

const ratings = [
  {value: 0, emoji: '😭'},
  {value: 1, emoji: '😟'},
  {value: 2, emoji: '🙂'},
  {value: 3, emoji: '🤩'},
];

const useStyles = makeStyles(theme => ({
  selectedEmoji: {
    border: '1px solid',
    borderColor: theme.palette.primary.main,
    padding: theme.spacing(0.7),
    margin: theme.spacing(0.3),
  },
  emoji: {
    border: '1px solid rgba(0,0,0,0)',
    padding: theme.spacing(0.7),
    margin: theme.spacing(0.3),
  },
}));

const FeedbackRating = ({rating, onSelect, size = 'small'}) => {
  const classes = useStyles();

  return (
    <>
      {ratings.map(({value, emoji}) => (
        <IconButton
          key={value}
          className={rating === value ? classes.selectedEmoji : classes.emoji}
          size={size}
          onClick={() => onSelect(value)}
        >
          {emoji}
        </IconButton>
      ))}
    </>
  );
};

export default FeedbackRating;
